export default "__VITE_ASSET__BpYKjFhc__"